import "./BannerAbout.css"


function BannerAbout() {
    return (
        <div className="banner-content">
            <div className="banner-background">

            </div>
        </div>
    );
}

export default BannerAbout;
